export const USERS = 'USERS';
export const CLIENTS = 'CLIENTS';
export const FORMS = 'FORMS';
export const CASE_PLANS = 'CASE_PLANS';
export const FORM_DATA = 'FORM_DATA';
export const FILE_DATA = 'FILE_DATA';
export const BASIC_REPORTS_TODAY = 'BASIC_REPORTS_TODAY';
export const ADVANCED_REPORTS_TODAY = 'ADVANCED_REPORTS_TODAY';
export const FORM_SUBMISSIONS_THIS_MONTH = 'FORM_SUBMISSIONS_THIS_MONTH';